export const ONBOARDING_CONFIG_PATH = '/v1/onboarding-config';
